import { Link } from "react-router-dom";
import { Package, Clock, CheckCircle2, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

const StatCard = ({ testId, label, value, icon: Icon, tone, to, delay, sub }) => (
  <Link to={to} data-testid={testId} className={cn("stat-card rise block h-full rounded-md border bg-[#111827] p-5 sm:p-6", tone, delay)}>
    <div className="flex items-start justify-between">
      <div className="font-mono text-[11px] uppercase tracking-widest text-slate-400">{label}</div>
      <Icon className="h-4 w-4 opacity-70" />
    </div>
    <div className="font-heading mt-3 text-4xl font-extrabold tracking-tight sm:text-5xl">{value ?? "—"}</div>
    {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
  </Link>
);

export const StatsBar = ({ stats }) => {
  const pct = stats?.total ? Math.round((stats.printed / stats.total) * 100) : 0;
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 sm:gap-6">
      <StatCard testId="stats-total-labels" label="Total labels" value={stats?.total} icon={Package} to="/labels?status=all"
        tone="border-slate-800 hover:border-blue-500/50 text-slate-100" delay="rise-1" sub={`${stats?.mappings ?? 0} SKU mappings loaded`} />
      <StatCard testId="stats-pending-labels" label="Pending print" value={stats?.pending} icon={Clock} to="/labels?status=pending"
        tone="border-amber-700/50 hover:border-amber-500 text-amber-300" delay="rise-2" sub="Waiting in queue" />
      <StatCard testId="stats-printed-labels" label="Printed" value={stats?.printed} icon={CheckCircle2} to="/labels?status=printed"
        tone="border-emerald-700/50 hover:border-emerald-500 text-emerald-300" delay="rise-3" sub={`${pct}% of all labels`} />
      <StatCard testId="stats-unmatched-labels" label="Unmatched SKU" value={stats?.unmatched} icon={AlertTriangle} to="/labels?warehouse=unmatched"
        tone={cn("border-red-800/50 hover:border-red-500 text-red-300", stats?.unmatched > 0 && "bg-red-950/30")} delay="rise-4" sub="Need manual mapping" />
    </div>
  );
};
